module.exports = __webpack_public_path__ + "static/12-ffcab37ff9bb9d8ccb119bca7c9765ee.jpg";